import React from 'react';
import styled from 'styled-components';

import ProtectionIcon from '@/assets/pretection.svg?react';
import { UiTypography } from '@/components/ui/Typography';

const InfoProtectionStyles = styled.section`
  body.dark & {
    background-color: #2b3126;
  }

  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #55a413;
  background-color: #e4eedc;

  .protection-icon {
    flex-shrink: 0;
    width: 20px;
    aspect-ratio: 0.83;
  }
`;

export const InfoProtection: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <InfoProtectionStyles className={className}>
      <ProtectionIcon className="protection-icon" />
      <UiTypography variant="body-medium">
        Your personal information is safely stored and protected. We do not
        disclose information to anyone.
      </UiTypography>
    </InfoProtectionStyles>
  );
};
